import { styled } from '../styled';

import { BG_COLORS, TEXT_COLORS } from './styles/colors';
import { CHIP_SIZES } from './styles/sizes';
import { ChipStyledType } from './types';

export const ChipStyled = styled('div')<ChipStyledType>(
  ({ variant, uppercase, size = 'm' }) => ({
    display: 'flex',
    width: 'fit-content',
    textTransform: uppercase ? 'uppercase' : 'none',
    backgroundColor: BG_COLORS[variant],
    borderRadius: 40,
    whiteSpace: 'nowrap',

    '.chip-text': {
      color: TEXT_COLORS[variant],
    },

    ...CHIP_SIZES[size],
  })
);
